export default __webpack_public_path__ + "static/media/monster_mint.563dc5db.png";